module.exports = __webpack_public_path__ + "img/invoice-de-male-banner-th.d4b81f3b.png";